module.exports = __webpack_public_path__ + "static/media/myphoto7.f1b95f3b.JPG";